import React from 'react';

const Right = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 11" {...props}>
    <path
      fill="#616161"
      d="M6 5.5l-.1-.3-5-5a.6.6 0 00-.7 0C0 .2-.1.5.2.7l4.5 4.7-4.6 4.7c-.2.2-.1.5 0 .7.3.2.6.1.9 0l4.9-5 .1-.4z"
    />
  </svg>
);

export default Right;
